import React, { useState, useEffect, useRef, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col, Modal, Dropdown, Tabs, Tab, Button, Form, } from "react-bootstrap";
import { faPlus, faXmark, faUpload, faPaperclip, faDownload, faCircleXmark, faLink, faCircleCheck, faChevronDown, faPencil, faGear, } from "@fortawesome/free-solid-svg-icons";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import Badge from "react-bootstrap/Badge";
import GenericJqxGrid from "./GenericJqxGrid";
// import JqxGrid from '../Components/Common/JqxGrid.js';
import edit from "../../../../assets/images/edit.png";
import Arcv from "../../../../assets/images/archive.svg";
import greencheck from "../../../../assets/images/green_check.png";
import greycheck from "../../../../assets/images/grey_check.png";
import orangecheck from "../../../../assets/images/orange_check.png";
import Activ from "../../../../assets/images/active.svg";
import trash from "../../../../assets/images/trash.png";
import Linktab from "../../../../assets/images/linktab.png";
import pen from "../../../../assets/images/pen.png";
import editpen from "../../../../assets/images/edit.png";
import Rapdf from "../../../../assets/images/pdf.png";
import screeninggreen from "../../../../assets/images/screening_green.png";
import screeninggrey from "../../../../assets/images/screening_grey.png";
import securitygreen from "../../../../assets/images/security_green.png";
import securityorange from "../../../../assets/images/security_orange.png";
import securityred from "../../../../assets/images/security_red.png";

import view from "../../../../assets/images/show.png";
import red_close from "../../../../assets/images/close.png";
import greencheck_1 from "../../../../assets/images/ck2.png";

import Cargoplane from "../../../../assets/images/plane.svg";
import ActivityComments from "../../../../Components/common/ActivityComments.js";
import ImageUpload from "../Components/Common/ImageUpload.js";

import { withRFSToken } from "../../../../Services/axios";
import { toast } from "react-toastify";
import { method } from "lodash";
import { applyOffsetToDateTime, CallApi, jqxCookieCall } from "../../../../Components/common/CommonFunctions.js";
import { useUserCheckQuery } from "../../../../redux/services/Auth.js";

const exportShipmentDatafields = [
  { name: 'id', type: 'string' },
  { name: 'cargohub_id', type: 'string' },
  { name: 'created_on', type: 'string' },
  { name: 'shipper', type: 'string' },
  { name: 'consignee', type: 'string' },
  { name: 'destination', type: 'string' },
  { name: 'job_nr', type: 'string' },
  { name: 'master_airwaybill', type: 'string' },
  { name: 'hawb', type: 'string' },
  { name: 'setting_status', type: 'string' },
  { name: 'setting_department', type: 'string' },
  { name: 'updated_on', type: 'string' },
  { name: 'updated_user', type: 'string' },
  { name: 'flight_lat', type: 'string' },
  { name: 'assigned_user', type: 'string' },
  { name: 'label_id', type: 'string' },
  { name: 'awb', type: 'string' },
  { name: 'cutt_off_date', type: 'string' },
  { name: 'cutoff_datetime', type: 'string' },
  { name: 'check_status_color', type: 'string' },
  { name: 'is_connected', type: 'string' },
];

const exportShipmentColumns = [
  { text: 'ID', filtertype: 'input', datafield: 'cargohub_id', width: '15%', cellclassname: '' },
  { text: 'Shipper', filtertype: 'input', datafield: 'shipper', width: '15%', cellclassname: '' },
  { text: 'Dest', filtertype: 'input', datafield: 'destination', width: '10%', cellclassname: '' },
  { text: 'Job No.', filtertype: 'input', datafield: 'job_nr', width: '18%', cellclassname: '' },
  { text: 'House AWB', filtertype: 'input', datafield: 'hawb', width: '15%', cellclassname: '' },
  { text: 'Master Airwaybill', filtertype: 'input', datafield: 'master_airwaybill', width: '15%', cellclassname: '' },
  {
    text: 'Label ID', filtertype: 'input', datafield: 'label_id', width: '10%', cellclassname: 'labelId_click',
    cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
      if (rowData.label_id) {
        return `
                    <div class="row_record_redirect jqx-grid-cell-left-align" style="margin-top:13px;">
                        <img src="${Linktab}" style="margin-right:5px; width:15px;" /> ${rowData.label_id}
                    </div>
                `;
      }
    }
  },
  // { text: 'Consignee', filtertype: 'input', datafield: 'consignee', width: '12%', cellclassname: '' },


  // { text: 'LAT', filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'flight_lat', width: '10%', cellclassname: '' },
];

const RecordExport = () => {
  const isMounted = useRef(false);
  const history = useHistory();
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const [isLoading, setIsLoading] = useState(true);
  const [totalRows, setTotalRows] = useState();
  const [filterApplied, setFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState("Active");
  const [resetFilter, setResetFilter] = useState(false);
  const gridRefs = {
    Active: useRef(null),
    Open: useRef(null),
    Archived: useRef(null),
    History: useRef(null),
    PickupPlanned: useRef(null),
    Booked: useRef(null),
    Invoicing: useRef(null),
    Trash: useRef(null),
  };
  const [gridData, setGridData] = useState([]);
  // Airwaybill modal state
  const [isAwbModalOpen, setIsAwbModalOpen] = useState(false);
  const [awbModalData, setAwbModalData] = useState({
    ids: [],
    airwaybill: "",
    cutOffTime: "",
  });
  // Action modal state for Open tab
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionSelectOptions, setActionSelectOptions] = useState([]);
  const [selectedActionOption, setSelectedActionOption] = useState(null);
  const [isLoadingActionOptions, setIsLoadingActionOptions] = useState(false);

  // Checks modal state
  const [showChecksModal, setShowChecksModal] = useState(false);
  const [checksFormData, setChecksFormData] = useState({});
  const [checksRecordId, setChecksRecordId] = useState(null);
  const [isLoadingChecks, setIsLoadingChecks] = useState(false);

  // Inline editing state
  const editingRowIds = useRef(new Set());
  const inlineFormData = useRef({});

  const handleInlineEditClick = (rowId, rowData) => {
    editingRowIds.current.add(rowId);
    inlineFormData.current[rowId] = {
      shipper: rowData.shipper,
      consignee: rowData.consignee,
      job_nr: rowData.job_nr,
      hawb: rowData.hawb,
    };
    // Refresh the grid to render inputs
    window.$(gridRefs[activeTab].current).jqxGrid('refresh');
  };

  const handleInlineSaveClick = async (rowId) => {
    const data = inlineFormData.current[rowId];
    if (!data) return;

    try {
      const payload = {
        id: rowId,
        shipper: data.shipper,
        consignee: data.consignee,
        job_nr: data.job_nr,
        hawb: data.hawb,
      };

      const res = await withRFSToken.post('shipment/save-export-shipment-record', payload);

      if (res.data.response_code === 200) {
        toast.success(res.data.response_msg || "Updated successfully");
        editingRowIds.current.delete(rowId);
        delete inlineFormData.current[rowId];
        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
      } else {
        toast.error(res.data.response_msg || "Failed to update");
      }
    } catch (error) {
      console.error("Error saving inline edit:", error);
      toast.error("Failed to update");
    }
  };

  const handleInlineCancelClick = (rowId) => {
    editingRowIds.current.delete(rowId);
    delete inlineFormData.current[rowId];
    window.$(gridRefs[activeTab].current).jqxGrid('refresh');
  };

  const [statusFilterItems, setStatusFilterItems] = useState();

  const fetchSettings = async () => {
    CallApi({
      endPoint: 'shipment/get-settings?tab=export&type=S',
      method: "GET",
      onSuccess: (data) => {
        const rows = data?.data?.Rows || [];
        const items = [
          ...rows.map(item => ({
            label: item.name,
            value: item.name,
          })),
        ];
        setStatusFilterItems(items);
        setIsLoading(false);
        setGridData([]);
      },
      onError: (msg) => toast.error(msg)
    });
  };



  const fetchOpenTabTotalRows = useCallback(async () => {
    try {
      const res = await withRFSToken.get("shipment/open-export-record-list", {
        params: {
          pagenum: 0,
          pagesize: 1,
          recordstartindex: 0,
          recordendindex: 1,
          filterscount: 0,
        },
      });
      const total =
        res?.data?.TotalRows ??
        res?.data?.totalRecords ??
        res?.data?.totalrecords;
      const parsedTotal = Number(total);
      if (!Number.isNaN(parsedTotal)) {
        setTotalRows(parsedTotal);
      }
    } catch (error) {
      console.error("Failed to fetch Open tab total rows:", error);
    }
  }, []);

  useEffect(() => {
    if (activeTab === "Active") {
      fetchOpenTabTotalRows();
    }
  }, [activeTab, fetchOpenTabTotalRows]);

  useEffect(() => {
    localStorage.removeItem("SHEdit");
    localStorage.removeItem("id");
    localStorage.removeItem("addexport");
    if (isMounted.current) return;
    fetchSettings();
    isMounted.current = true;
  }, []);

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null);
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == "Active") {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else if (tab == "Open") {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Open: {} });
      }, 1);
    } else if (tab == "Archived") {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);

    } else if (tab == "History") {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ History: {} });
      }, 1);


    } else if (tab == "PickupPlanned") {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ PickupPlanned: {} });
      }, 1);
    }
    else if (tab == "Booked") {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Booked: {} });
      }, 1);
    }
    else if (tab == "Invoicing") {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Invoicing: {} });
      }, 1);
    }
    else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Trash: {} });
      }, 1);
    }
  };
  const OrderViewDetailsClick = (rowData) => {
    if (!rowData) return;
    localStorage.removeItem("SHEdit"); // or a "SHView" key if you want to distinguish view vs edit
    localStorage.setItem("SHEdit", JSON.stringify(rowData.id));
    localStorage.setItem("ccbackUrl", "/ForwarderShipments/ShipmentRecords");
    localStorage.setItem("AddShipmentType", "export");
    history.push("/ForwarderShipments/AddShipmentRecords"); // or a read-only view route if one exists
  };

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationInfo, setConfirmationInfo] = useState("");
  const [deleteFunction, setDeleteFunction] = useState(null);
  const [deleteId, setDeleteId] = useState("");
  const [userDetails, setUserDetails] = useState();

  let checkUlds = [];
  let filterForCheck = false;
  const { data: myData } = useUserCheckQuery('', {
    // skip: pageDetails.pagesize === 0,
  });
  useEffect(() => {
    if (myData?.response_data) {
      setUserDetails(myData?.response_data);
    }
  }, [myData]);

  const orgUser = localStorage.getItem('User');
  const clickTimerRef = useRef(null);
  const CLICK_DELAY = 250;
  useEffect(() => {
    let LoginUser = localStorage.getItem("LoginUser");
    let userName = localStorage.getItem("User");
    let saveFilter = "";
    let allFilter = [];
    if (LoginUser == "E") {
      saveFilter =
        '[{"datafield":"assigned_user","filters":[{"condition":"CONTAINS","operator":1,"value":"' +
        userName +
        '"}]}]';
    } else {
      saveFilter =
        '[{"datafield":"assigned_user","filters":[{"condition":"CONTAINS","operator":1,"value":""}]}]';
    }
    let localStorageFilter = localStorage.getItem("srFilter");
    if (localStorageFilter) {
      localStorageFilter = JSON.parse(localStorageFilter);
      saveFilter = JSON.parse(saveFilter);
      allFilter = JSON.stringify([...saveFilter, ...localStorageFilter]);
    } else {
      allFilter = saveFilter;
    }
    localStorage.setItem("srFilter", allFilter);

    if (gridRefs[activeTab]?.current) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall();
      let datafields = [];

      if (activeTab == "Open") {
        datafields = [
          { name: "id", type: "string" },
          { name: "awbId", type: "string" },
          { name: "cutoff_datetime", type: "string" },
          { name: "pick_status", type: "string" },
          { name: "take_in", type: "date" },
          { name: "receipt", type: "string" },
          { name: "bonded", type: "string" },
          { name: "label_id", type: "string" },
          { name: "shipment_id", type: "string" },
          { name: "location", type: "string" },
          { name: "destination", type: "string" },
          { name: "expected_pieces", type: "string" },
          { name: "expected_weight", type: "string" },
          { name: "received_pieces", type: "string" },
          { name: "received_weight", type: "string" },
          { name: "shipper_name", type: "string" },
          { name: "shipper_city", type: "string" },
          { name: "address_lbl", type: "string" },
          { name: "dg", type: "string" },
          { name: "dg_lbl", type: "string" },
          { name: "security", type: "string" },
          { name: "damage", type: "string" },
          { name: "remarks", type: "string" },
          { name: "accepted_by", type: "string" },
          { name: "station", type: "string" },
          { name: "record_id", type: "string" },
        ];
      } else if (activeTab !== "History") {
        datafields = [
          { name: "id", type: "string" },
          { name: "ground_handler", type: "string" },
          { name: "aging_days", type: "string" },
          { name: "cargohub_id", type: "string" },
          { name: "created_on", type: "string" },
          { name: "created_user", type: "string" },
          { name: "shipper", type: "string" },
          { name: "consignee", type: "string" },
          { name: "destination", type: "string" },
          { name: "job_nr", type: "string" },
          { name: "master_airwaybill", type: "string" },
          { name: "hawb", type: "string" },
          { name: "setting_status", type: "string" },
          { name: "setting_department", type: "string" },
          { name: "updated_on", type: "string" },
          { name: "updated_user", type: "string" },
          { name: "flight_lat", type: "string" },
          { name: "assigned_user", type: "string" },
          { name: "label_id", type: "string" },
          { name: "awb", type: "string" },
          { name: "cutt_off_date", type: "string" },
          { name: "cutoff_datetime", type: "string" },
          { name: "check_status_color", type: "string" },
          { name: "is_connected", type: "string" },
          { name: "screening", type: "string" },
          { name: "sec_status", type: "string" },
          { name: "label_count", type: "string" },
          { name: "connected_records", type: "string" },
          { name: "ttl_weight", type: "string" },
          { name: "ttl_pcs", type: "string" },
          { name: "assigned_user", type: "string" },
          { name: "receipt", type: "string" },
          { name: "event", type: "string" },
        ];
      } else {
        datafields = []
      }

      const source = {
        datatype: "json",
        datafields: datafields,
        id: `${activeTab}-`,
        url: activeTab === "Open" ? `${process.env.REACT_APP_RFS_URL}shipment/open-export-record-list` : activeTab != "History" ? `${process.env.REACT_APP_RFS_URL}shipment/export-shipment-record-list?tab=${activeTab}` : `${process.env.REACT_APP_RFS_URL}shipment-export/get-export-history`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader("Authorization", token);
        // },
        pagesize: 50,
        filter: function (allfilters) {
          const filterInfo = window.$(gridRefs[activeTab]?.current).jqxGrid("getfilterinformation");
          // Check if there are filters with meaningful (non-empty) values
          const hasMeaningfulFilters = filterInfo && filterInfo.some((f) => {
            const filters = f.filter?.getfilters();
            return filters && filters.some((fl) => {
              const value = fl.value;
              return value !== null && value !== undefined && value !== "";
            });
          });

          if (hasMeaningfulFilters) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          if (activeTab === "Open") {
            setTotalRows(data?.TotalRows);
          }
        },
        sort: function () {
          window
            .$(gridRefs[activeTab].current)
            .jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };

      const dataAdapter = new window.$.jqx.dataAdapter(source);

      const columns =
        activeTab == "Open"
          ? [
            { text: "Take In", filtertype: "range", cellsformat: "dd-MM-yyyy", filtermode: "range", datafield: "take_in", width: "5%", cellclassname: "", },
            { text: "Label ID", filtertype: "input", datafield: "label_id", width: "10%", cellclassname: "", },
            { text: "Shipment ID", filtertype: "input", datafield: "shipment_id", width: "10%", cellclassname: "", },
            { text: "Record ID", filtertype: "input", datafield: "record_id", width: "7%", cellclassname: "", },
            { text: "Remarks", filtertype: "input", datafield: "remarks", width: "7%", cellclassname: "", },
            { text: "Shipper Name", filtertype: "input", datafield: "shipper_name", width: "7%", cellclassname: "", },
            // { text: "Shipper City", filtertype: "input", datafield: "shipper_city", width: "7%", cellclassname: "", },
            { text: "Destination", filtertype: "input", datafield: "destination", width: "7%", cellclassname: "", },
            { text: "Bonded", filtertype: "input", datafield: "bonded", width: "6%", cellclassname: "", },
            { text: "Expected pcs", filtertype: "input", datafield: "expected_pieces", width: "7%", cellclassname: "", },
            { text: "Expected wgt", filtertype: "input", datafield: "expected_weight", width: "7%", cellclassname: "", },
            { text: "Received pcs", filtertype: "input", datafield: "received_pieces", width: "7%", cellclassname: "", },
            { text: "Received wgt", filtertype: "input", datafield: "received_weight", width: "6%", cellclassname: "", },
            { text: "Damage", filtertype: "input", datafield: "damage", width: "6%", cellclassname: "", },
            // { text: "Station", filtertype: "input", datafield: "station", width: "6%", cellclassname: "", },
            {
              text: 'Receipt', filterable: false, width: '5%', cellclassname: '', dataField: 'receipt',
              cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
                  defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                }
                return (
                  defaultHtml
                );
              },
            },
          ]
          : activeTab != "History" ? [
            {
              text: "Actions",
              cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                const rowId = rowData.id || rowData.uid;
                if (editingRowIds.current.has(rowId)) {
                  return `<div class="grid_actions">
                  <img src="${greencheck_1}" class="row_inline_save" style="cursor: pointer; width: 16px; margin-right: 5px;" />
                  <span class="row_inline_cancel" style="cursor: pointer; color: red; font-weight: bold; margin-left: 5px;"><img src="${red_close}"/></span>
                  </div>`;
                }
                return `<div class="grid_actions">
                <img src="${view}" class="row_edit" style="cursor: pointer; margin-right: 5px;" />
                <img src="${edit}" class="row_inline_edit" style="cursor: pointer;" />
                </div>`;
              },
              width: "4%",
              filterable: false,
            },
            { text: "Record ID", filtertype: "input", datafield: "cargohub_id", width: "8%", cellclassname: "", },
            { text: "Job No.", filtertype: "input", datafield: "job_nr", width: "8%", cellclassname: "", },
            {
              text: "HAWB", filtertype: "input", datafield: "hawb", width: "8%", cellclassname: "",
              cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                const rowId = rowData.id || rowData.uid;
                if (editingRowIds.current.has(rowId)) {
                  const value = inlineFormData.current[rowId]?.hawb || cellValue || "";
                  return `<div style="width: 100%; height: 100%; padding: 5px;"><input type="text" class="inline_input_hawb" data-row-id="${rowId}" value="${value}" style="width: 100%; height: 100%; border: 1px solid #ccc; border-radius: 4px; padding: 0 5px;" /></div>`;
                }
                return defaultHtml;
              }
            },
            // {
            //   text: "Department", filtertype: "input", datafield: "department", width: "8%", cellclassname: "",
            //   cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
            //     const rowdata = rowData?.setting_department?.name ;
            //     if(rowdata)return `<div style="margin-top:13px;margin-left:10px;" class="">${rowdata}</div>`;
            //     else
            //       return "";
            //   }
            // },
            {
              text: "Shipper", filtertype: "input", datafield: "shipper", width: "8%", cellclassname: "",
              cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                const rowId = rowData.id || rowData.uid;
                if (editingRowIds.current.has(rowId)) {
                  const value = inlineFormData.current[rowId]?.shipper || cellValue || "";
                  return `<div style="width: 100%; height: 100%; padding: 5px;"><input type="text" class="inline_input_shipper" data-row-id="${rowId}" value="${value}" style="width: 100%; height: 100%; border: 1px solid #ccc; border-radius: 4px; padding: 0 5px;" /></div>`;
                }
                return defaultHtml;
              }
            },
            { text: "Dest", filtertype: "input", datafield: "destination", width: "3%", cellclassname: "", },
            {
              text: "AirwayBill No", filtertype: "input", datafield: "master_airwaybill", width: "9%", cellclassname: "",
              cellsrenderer: function (rowIndex, dataField, cellValue) {
                return cellValue
                  ? `<div class="jqx-grid-cell-left-align" style="margin-top: 12px; margin-left:5px">${cellValue}<span class="screen_re screen_edit"><img src="${editpen}" /></span></div>`
                  : `<div class="set_fn"><span class="screen screen_edit"><img src="${pen}" /> Set</span></div>`;
              },
            },
            { text: "LAT", filtertype: "range", cellsformat: "dd-MM-yyyy", filtermode: "range", datafield: "cutoff_datetime", width: "7%", cellclassname: "", },
            { text: "Ground Handler", filtertype: "input", datafield: "ground_handler", width: "8%", cellclassname: "", },

            // { text: "TTL Pcs", filtertype: "input", datafield: "ttl_pcs", width: "4%", cellclassname: "", },
            // { text: "TTL Weight", filtertype: "input", datafield: "ttl_weight", width: "5%", cellclassname: "", },
            {
              text: "Linked", datafield: "linked", filtertype: "input", width: "3%", cellclassname: "",
              cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                const rowCount = rowData?.connected_records?.length ?? 0;
                if (rowCount == 0) { return "" }
                return `<div style="margin-top:13px;margin-left:10px; cursor: pointer; color: green;" class="">
                ${rowCount}
                </div>`;
              },
            },
            {
              text: "Status", filtertype: "input", datafield: "status", width: "8%", cellclassname: "", filtertype: "checkedlist", filteritems: statusFilterItems,
              cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                const rowdata = rowData?.setting_status?.name;
                if (rowdata) return `<div style="margin-top:13px;margin-left:10px;" class="">${rowdata}</div>`;
                else
                  return "";
              }
            },
            {
              text: "Checks", datafield: "check_status_color", filterable: false, width: "4%", cellclassname: "checks-clickable",
              cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                const iconMap = {
                  grey: greycheck,
                  green: greencheck,
                  orange: orangecheck,
                };
                const iconSrc = iconMap[cellValue];
                const rowId = rowData?.id || rowData?.bounddata?.id || "";
                return iconSrc
                  ? `<div style="margin-top:13px;margin-left:10px; cursor: pointer;" class="checks-cell" data-row-id="${rowId}">
                <img src="${iconSrc}" alt="${cellValue}" style="width:16px; height:16px;" />
                </div>`
                  : "";
              },
            },
            // {
            //   text: "Screening", datafield: "screening",  filterable : false, width: "5%", cellclassname: "screening-clickable",
            //   cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
            //     const rowId = rowData?.id || rowData?.bounddata?.id || "";
            //     const iconSrc = cellValue === "1" ? screeninggreen : screeninggrey;
            //     return `<div style="margin-left:10px; margin-top:13px; cursor: pointer;" class="screening-cell" data-row-id="${rowId}">
            //     <img src="${iconSrc}" alt="${cellValue}" style="width:16px; height:16px;" />
            //     </div>`;
            //   },
            // },
            {
              text: "Security", datafield: "sec_status", filterable: false, width: "4%", cellclassname: "sec-status-clickable",
              cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                const rowId = rowData?.id || rowData?.bounddata?.id || "";

                let iconSrc;
                if (rowData?.screening_planned == 1) {
                  iconSrc = securityorange;
                } else if (cellValue === "U") {
                  iconSrc = securityred;
                } else if (cellValue === "K" || cellValue === "S") {
                  iconSrc = securitygreen;
                } else {
                  iconSrc = securityred;
                }

                return `<div style="margin-left:10px; margin-top:13px; cursor: pointer;" class="sec-status-cell" data-row-id="${rowId}">
                <img src="${iconSrc}" alt="${cellValue}" style="width:16px; height:16px;" />
                </div>`;
              },
            },
            {
              text: "Assigned To", datafield: "assigned_user", width: "9%", cellclassname: "",
              filtertype: 'checkedlist',
              filteritems: [
                { label: userDetails?.user_name, value: userDetails?.user_name },
                { label: 'All', value: '' },

              ],
              cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
                if (cellValue)
                  return `<div style="margin-left:10px; margin-top:13px; cursor: pointer;" class="sec-status-cell">${cellValue.first_Name} ${cellValue.last_Name}</div>`;
                else
                  return ""
              },
            },
            { text: "Aging Days", filtertype: "input", datafield: "aging_days", width: "5%", cellclassname: "", },
          ] : [
            {
              text: "Record ID", filtertype: "input", datafield: "cargohub_id", width: "12%", cellclassname: "",
              cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, rowData) => {
                const formatted = rowData?.shipment?.cargohub_id || "";
                return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${formatted}</div>`;
              }
            },

            {
              text: "Job No.", filtertype: "input", datafield: "job_nr", width: "12%", cellclassname: "",
              cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, rowData) => {
                const formatted = rowData?.shipment?.job_nr || "";
                return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${formatted}</div>`;
              }
            },

            {
              text: "HAWB", filtertype: "input", datafield: "hawb", width: "12%", cellclassname: "",
              cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, rowData) => {
                const formatted = rowData?.shipment?.hawb || "";
                return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${formatted}</div>`;
              }
            },

            {
              text: "MAWB", filtertype: "input", datafield: "master_airwaybill", width: "12%", cellclassname: "",
              cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, rowData) => {
                const formatted = rowData?.shipment?.master_airwaybill || "";
                return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${formatted}</div>`;
              }
            },
            {
              text: "Created At", filtertype: "input", datafield: "created_at", width: "12%", cellclassname: "",
              cellsrenderer: function (row, columnfield, value) {
                const formatted = applyOffsetToDateTime(value, "L");
                return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${formatted}</div>`;
              }
            },
            {
              text: "Event", filtertype: "input", datafield: "event", width: "12%", cellclassname: "",
              cellsrenderer: function (row, columnfield, value) {
                const formatted = value
                  ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
                  : "";

                return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${formatted}</div>`;
              }
            },
          ];

      // Define nested columns for connected records
      const nestedColumns = [
        { text: "Take In", filtertype: "range", cellsformat: "dd-MM-yyyy", filtermode: "range", datafield: "take_in", width: "5%", cellclassname: "", },
        { text: "Label ID", filtertype: "input", datafield: "label", width: "10%", cellclassname: "", },
        { text: "Shipment ID", filtertype: "input", datafield: "shipment_number", width: "10%", cellclassname: "", },
        { text: "Record ID", filtertype: "input", datafield: "record_id", width: "7%", cellclassname: "", },
        { text: "Shipper Name", filtertype: "input", datafield: "shipper_name", width: "6%", cellclassname: "", },
        { text: "Shipper City", filtertype: "input", datafield: "shipper_city", width: "6%", cellclassname: "", },
        { text: "Destination", filtertype: "input", datafield: "Destination", width: "6%", cellclassname: "", },
        {
          text: 'Receipt', filterable: false, width: '5%', cellclassname: '', dataField: 'receipt',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            if (cellValue) { defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>"; }
            return (
              defaultHtml
            );
          },
        },
        { text: "Bonded", filtertype: "input", datafield: "bonded", width: "4%", cellclassname: "", },
        { text: "Expected pcs", filtertype: "input", datafield: "expected_total_pieces", width: "6%", cellclassname: "", },
        { text: "Expected wgt", filtertype: "input", datafield: "expected_total_weight", width: "6%", cellclassname: "", },
        { text: "Received pcs", filtertype: "input", datafield: "total_pieces", width: "6%", cellclassname: "", },
        { text: "Received wgt", filtertype: "input", datafield: "total_weight", width: "6%", cellclassname: "", },
        { text: "Damage", filtertype: "input", datafield: "damage", width: "5%", cellclassname: "", },
        { text: "Station", filtertype: "input", datafield: "station_code", width: "5%", cellclassname: "", },
      ];

      // Initialize nested grid for connected records
      const initrowdetails = (index, parentElement, gridElement, record) => {
        const id = record.uid.toString();
        const connectedRecords = dataAdapter.loadedData.Rows[id].connected_records || [];
        const nestedGridContainer = parentElement.children[0];

        parentElement.addEventListener("click", (event) => {
          const target = event.target;
          if (window.$(target).hasClass("jqx-icon-arrow-right")) {
            event.stopPropagation();
          }
        });

        const nestedSource = {
          datatype: "json",
          id: "connectedRecordsChildID",
          datafields: [
            { name: "id", type: "string" },
            { name: "awbId", type: "string" },
            { name: "cutoff_datetime", type: "string" },
            { name: "pick_status", type: "string" },
            { name: "take_in", type: "date" },
            { name: "receipt", type: "string" },
            { name: "bonded", type: "string" },
            { name: "label", type: "string" },
            { name: "shipment_number", type: "string" },
            { name: "location", type: "string" },
            { name: "Destination", type: "string" },
            { name: "expected_total_pieces", type: "string" },
            { name: "expected_total_weight", type: "string" },
            { name: "received_pieces", type: "string" },
            { name: "received_weight", type: "string" },
            { name: "shipper_name", type: "string" },
            { name: "shipper_city", type: "string" },
            { name: "address_lbl", type: "string" },
            { name: "dg", type: "string" },
            { name: "dg_lbl", type: "string" },
            { name: "security", type: "string" },
            { name: "damage", type: "string" },
            { name: "remarks", type: "string" },
            { name: "accepted_by", type: "string" },
            { name: "station_code", type: "string" },
            { name: "record_id", type: "string" },
            { name: "total_pieces", type: "string" },
            { name: "total_weight", type: "string" },
            { name: "receipt", type: "string" },
          ],
          localdata: connectedRecords,
        };

        const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);
        const nestedGridOptions = {
          width: "100%",
          pageable: false,
          sortable: false,
          // pageSize: 15,
          autoheight: false,
          height: 10 * 45,
          selectionmode: activeTab != "History" ? "checkbox" : "none", // checkbox
          source: nestedDataAdapter,
          filterable: false,
          columns: nestedColumns,
          rowdetails: false,
          rowsheight: 45,
          showemptyrow: false,
          ready: function () {
            // Manually set row IDs starting from 0
            const rows = window.$(nestedGridContainer).jqxGrid("getrows");
            for (let i = 0; i < rows.length; i++) {
              const rowid = i; // Use index as the new row ID
              const row = rows[i];
              window.$(nestedGridContainer).jqxGrid("setcellvalue", row.uid, "uid", rowid);
              window.$(nestedGridContainer).jqxGrid("updaterow", rowid, row);
              window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr("row-id", rowid);
            }
          },
        };

        window.$(nestedGridContainer).jqxGrid(nestedGridOptions);

        window.$(nestedGridContainer).on('rowselect', function (event) {
          const args = event.args;
          const rowData = args.row;
          if (rowData) {
            setNestedGridSelect(prev => {
              if (!prev.some(item => item.uid === rowData.uid)) {
                return [...prev, rowData];
              }
              return prev;
            });
          }
        });

        window.$(nestedGridContainer).on('rowunselect', function (event) {
          const args = event.args;
          const rowData = args.row;
          if (rowData) {
            setNestedGridSelect(prev => prev.filter(item => item.uid !== rowData.uid));
          }
        });
      };

      const gridOptions = {
        width: "100%",
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: activeTab != "History" ? "checkbox" : "none", // checkbox
        pageable: true,
        pageSize: 20,
        pagesizeoptions: ["50", "100", "200", "500"],
        pagerButtonsCount: 5,
        pagerMode: "advanced",
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rowdetails: activeTab !== "Open" && activeTab !== "History",
        initrowdetails: activeTab !== "Open" && activeTab !== "History" ? initrowdetails : undefined,
        rowdetailstemplate:
          activeTab !== "Open" && activeTab !== "History"
            ? {
              rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
              rowdetailsheight: 10 * 45,
              rowdetailshidden: true,
            }
            : undefined,
        rendered: function () {
          const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
          (checkUlds).forEach(uldNumber => {
            rows.forEach((element, index) => {
              if (element.uld_number == uldNumber) {
                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
              }
            });
          });
        },
        rendergridrows: function (params) {
          return params.data;
        },
        ready: function () {
          localStorgeFilter();
        },
      };

      window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find(".jqx-grid-column-header").css("background-color", "white");
      window.$(gridRefs[activeTab].current).on("click", ".row_edit", function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid("getrowid", rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
          if (rowData) {
            const innerData = rowData.id;
            localStorage.removeItem("SHEdit");
            localStorage.setItem("SHEdit", JSON.stringify(innerData));
            localStorage.setItem(
              "ccbackUrl",
              "/ForwarderShipments/ShipmentRecords"
            );
            localStorage.setItem("AddShipmentType", "export");
            history.push("/ForwarderShipments/AddShipmentRecords");
          } else {
            console.error("No data found for the given row index.");
          }
        } else {
          console.error(
            "Bound index could not be retrieved. Check the row index and data binding."
          );
        }
      });

      window.$(gridRefs[activeTab].current).on("click", ".row_delete", function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", rowIndex);
        setDeleteId(rowData.id);
        handleShowConfirmation(deleteRow);
      });

      window.$(gridRefs[activeTab].current).on("click", ".screen_edit", function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid("getrowid", rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
          if (rowData) {
            openAwbModal(
              rowData.id,
              rowData.master_airwaybill || "",
              rowData.cutoff_datetime || ""
            );
          }
        }
      });
      window.$(gridRefs[activeTab].current).on("click", ".screen_re", function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid("getrowid", rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
          if (rowData) {
            openAwbModal(
              rowData.id,
              rowData.master_airwaybill || "",
              rowData.cutoff_datetime || ""
            );
          }
        }
      });
      window.$(gridRefs[activeTab].current).on("click", ".checks-cell", function (e) {
        e.stopPropagation();
        const rowId = window.$(this).attr("data-row-id");
        if (rowId) {
          openChecksModal(rowId);
        } else {
          const rowDiv = window.$(this).closest('[role="row"]');
          const rowIndex = window.$(rowDiv).attr("row-id");
          if (rowIndex !== undefined) {
            const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
            const pageIndex = pagingInfo.pagenum;
            const pageSize = pagingInfo.pagesize;
            const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
            const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
            if (rowData && rowData.id) {
              openChecksModal(rowData.id);
            }
          }
        }
      });

      window.$(gridRefs[activeTab].current).on("click", ".screening-cell", function (e) {
        e.stopPropagation();
        const rowId = window.$(this).attr("data-row-id");
        if (rowId) {
          openChecksModal(rowId, "screening");
        } else {
          const rowDiv = window.$(this).closest('[role="row"]');
          const rowIndex = window.$(rowDiv).attr("row-id");
          if (rowIndex !== undefined) {
            const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
            const pageIndex = pagingInfo.pagenum;
            const pageSize = pagingInfo.pagesize;
            const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
            const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
            if (rowData && rowData.id) {
              openChecksModal(rowData.id, "screening");
            }
          }
        }
      });

      window.$(gridRefs[activeTab].current).on("click", ".sec-status-cell", function (e) {
        e.stopPropagation();
        const rowId = window.$(this).attr("data-row-id");
        if (rowId) {
          openChecksModal(rowId, "sec_status");
        } else {
          // Fallback: get row data from the grid
          const rowDiv = window.$(this).closest('[role="row"]');
          const rowIndex = window.$(rowDiv).attr("row-id");
          if (rowIndex !== undefined) {
            const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
            const pageIndex = pagingInfo.pagenum;
            const pageSize = pagingInfo.pagesize;
            const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
            const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
            if (rowData && rowData.id) {
              openChecksModal(rowData.id, "sec_status");
            }
          }
        }
      });

      window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
        window.$(row).on("mouseover", () => {
          window.$(row).addClass("row-hover");
        });
        window.$(row).on("mouseout", () => {
          window.$(row).removeClass("row-hover");
        });
      });

      window.$(gridRefs[activeTab].current).on("rowselect", (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const rowKey =
            activeTab === "Open" ? selectedRow.awbId : selectedRow.id;
          const selectedRowId = selectedRow.uid;

          if (!checkUlds.includes(rowKey)) {
            checkUlds.push(rowKey);
          }

          setGridSelect((prevGridSelect) => {
            if (
              !prevGridSelect.some(
                (row) => (activeTab === "Open" ? row.awbId : row.id) === rowKey
              )
            ) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allRows = window.$(gridRefs[activeTab].current).jqxGrid("getrows");
            setGridSelect(allRows);
          } else {
            setGridSelect([]);
          }
        }
      });

      window.$(gridRefs[activeTab].current).on("rowunselect", (event) => {
        if (event.args.row) {
          const unselectedRow = event.args.row;
          const unselectedRowKey =
            activeTab === "Open" ? unselectedRow.awbId : unselectedRow.id;

          setGridSelect((prevSelection) =>
            prevSelection.filter(
              (row) =>
                (activeTab === "Open" ? row.awbId : row.id) !== unselectedRowKey
            )
          );
          if (!checkUlds.includes(unselectedRowKey)) {
            checkUlds.push(unselectedRowKey);
          } else {
            checkUlds = checkUlds.filter((item) => item !== unselectedRowKey);
          }
        }
      });
      window.$(gridRefs[activeTab].current).off("cellclick");
      window.$(gridRefs[activeTab].current).on("cellclick", (event) => {
        const args = event.args.row.bounddata;
        // if (event.args.columnindex > 3 && ![6, 7, 12, 13, 14].includes(event.args.columnindex)) {
        if (event.args.columnindex === 3) {
          if (clickTimerRef.current) {
            clearTimeout(clickTimerRef.current);
            clickTimerRef.current = null;
          }
          clickTimerRef.current = setTimeout(() => {
            if (gridSelect) {
              gridSelect.forEach((item) => {
                const selectedRowBoundIndex = item.boundindex;
                window.$(gridRefs[activeTab].current).jqxGrid("unselectrow", selectedRowBoundIndex);
              });
            }
            loadDetails(args.id);
          }, CLICK_DELAY);
        }
      });

      window.$(gridRefs[activeTab].current).on("click", ".labelId_click", function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid("getrowid", rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
          if (rowData) {
            const filter = [
              {
                datafield: "label_id",
                filters: [
                  {
                    condition: "CONTAINS",
                    operator: 1,
                    value: rowData.label_id,
                  },
                ],
              },
            ];
            localStorage.setItem("srFilter", JSON.stringify(filter));
            localStorage.setItem("Ftab_export", "instock");
            history.push("/ForwarderShipments/Export");
          } else {
            console.error("No data found for the given row index.");
          }
        } else {
          console.error(
            "Bound index could not be retrieved. Check the row index and data binding."
          );
        }
      });

      // Inline Edit Event Handlers
      window.$(gridRefs[activeTab].current).off("click", ".row_inline_edit");
      window.$(gridRefs[activeTab].current).on("click", ".row_inline_edit", function (e) {
        e.stopPropagation();
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
        const pageIndex = pagingInfo.pagenum;
        const pageSize = pagingInfo.pagesize;
        const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
        if (rowData) {
          handleInlineEditClick(rowData.id, rowData);
        }
      });

      window.$(gridRefs[activeTab].current).off("click", ".row_inline_save");
      window.$(gridRefs[activeTab].current).on("click", ".row_inline_save", function (e) {
        e.stopPropagation();
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
        const pageIndex = pagingInfo.pagenum;
        const pageSize = pagingInfo.pagesize;
        const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
        if (rowData) {
          handleInlineSaveClick(rowData.id);
        }
      });

      window.$(gridRefs[activeTab].current).off("click", ".row_inline_cancel");
      window.$(gridRefs[activeTab].current).on("click", ".row_inline_cancel", function (e) {
        e.stopPropagation();
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
        const pageIndex = pagingInfo.pagenum;
        const pageSize = pagingInfo.pagesize;
        const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
        if (rowData) {
          handleInlineCancelClick(rowData.id);
        }
      });
      window.$(gridRefs[activeTab].current).off("change", ".inline_input_hawb");
      window.$(gridRefs[activeTab].current).on("change", ".inline_input_hawb", function (e) {
        const rowId = window.$(this).attr("data-row-id");
        const val = window.$(this).val();
        if (inlineFormData.current[rowId]) {
          inlineFormData.current[rowId].hawb = val;
        }
      });
      window.$(gridRefs[activeTab].current).off("celldoubleclick");
      window.$(gridRefs[activeTab].current).on("celldoubleclick", function (event) {
        if (clickTimerRef.current) {
          clearTimeout(clickTimerRef.current);
          clickTimerRef.current = null;
        }
        const args = event.args;
        const datafield = args.datafield;
        if (['cargohub_id', 'label_id', 'shipment_id', 'record_id', 'hawb', 'master_airwaybill'].includes(datafield)) {
          const cellValue = args.value;
          if (cellValue !== null && cellValue !== undefined && String(cellValue).trim() !== '') {
            navigator.clipboard.writeText(String(cellValue))
              .then(() => {
                toast.success("Copied to clipboard: " + cellValue);
              })
              .catch(err => {
                // optional error handling
                // console.error("Failed to copy:", err);
              });
          }
        }
      });
    }
  }, [gridData]);

  function localStorgeFilter() {
    let savedFilters = localStorage.getItem("srFilter");
    if (savedFilters) {
      savedFilters = JSON.parse(localStorage.getItem("srFilter"));
      savedFilters.forEach((element) => {
        const filterValue = element.filters[0].value;
        if (filterValue !== null && filterValue !== undefined && filterValue !== "") {
          const filterGroup = new window.$.jqx.filter();
          const filterCondition = element.filters[0].condition ?? "CONTAINS"; // Adjust the condition as needed
          const filter = filterGroup.createfilter(
            "stringfilter",
            filterValue,
            filterCondition
          );
          filterGroup.addfilter(1, filter);
          window.$(gridRefs[activeTab].current).jqxGrid("addfilter", element.datafield, filterGroup);
        }
      });
      window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
      // setApplyFilter(false);
    }
    localStorage.removeItem("srFilter");
  }
  const [editMode, setEditMode] = useState(false);
  const [userList, setUserList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [formData, setFormData] = useState({});

  const formatAwb = (value) => {
    value = (value || "").replace(/[^\d]/g, "");
    let formatted = "";
    if (value.length > 3) {
      formatted += value.substr(0, 3) + "-";
      value = value.substr(3);
    }
    if (value.length > 4) {
      formatted += value.substr(0, 4) + " ";
      value = value.substr(4);
    }
    formatted += value;
    return formatted.substr(0, 13);
  };

  const openAwbModal = (id, airwaybill, cutOffTime) => {
    let targetIds = [];
    let awbValue = airwaybill;
    let cutValue = cutOffTime;

    if (Array.isArray(id)) {
      targetIds = id.filter(Boolean);
    } else if (id) {
      targetIds = [id];
    } else {
      const selectedActiveRows = gridSelect.filter((row) => row?.id);
      targetIds = selectedActiveRows.map((row) => row.id);

      if (targetIds.length === 0) {
        toast.error("Select at least one record from the Active tab.");
        return;
      }

      if (targetIds.length === 1) {
        const selectedRow = selectedActiveRows[0];
        if (!awbValue) {
          awbValue = selectedRow?.master_airwaybill || "";
        }
        if (!cutValue) {
          cutValue = selectedRow?.cutoff_datetime || cutValue;
        }
      } else {
        awbValue = "";
      }
    }

    if (!cutValue) {
      cutValue = getCurrentDateTime();
    }

    setAwbModalData({
      ids: targetIds,
      airwaybill: awbValue ? formatAwb(awbValue) : "",
      cutOffTime: cutValue,
    });
    setIsAwbModalOpen(true);
  };

  const closeAwbModal = () => {
    setIsAwbModalOpen(false);
    setAwbModalData({ ids: [], airwaybill: "", cutOffTime: "" });
  };

  const handleAwbChange = (val) => {
    setAwbModalData((prev) => ({ ...prev, airwaybill: formatAwb(val) }));
  };

  const updateAwb = async () => {
    const awb = awbModalData.airwaybill;
    if (!awb || awb.length !== 13) {
      toast.error("The air way bill must be like 000-0000 0000");
      return;
    }
    if (!awbModalData.ids || awbModalData.ids.length === 0) {
      toast.error("No shipment records selected.");
      return;
    }
    try {
      const payload = {
        export_shipment_record_id: awbModalData.ids,
        airway_bill: awb,
        cutOffTime: awbModalData.cutOffTime,
      };
      const res = await withRFSToken.post(
        "shipment/connect-airway-bill",
        payload
      );
      if (res.data.response_code === 200) {
        toast.success(res.data.response_msg || "Updated successfully");
        closeAwbModal();
        setGridSelect([]);
        window.$(gridRefs[activeTab].current).jqxGrid("clearselection");
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
      } else {
        toast.error(res.data.response_msg || "Failed to update");
      }
    } catch (error) {
      console.error("Error updating airwaybill:", error);
    }
  };

  const loadDetails = async (uldNumber) => {
    try {
      const res = await withRFSToken.post(
        `shipment/export-shipment-record-details/${uldNumber}`,
        {}
      );
      // .then(function (res) {
      if (res.data.response_code == 200) {
        const innerData = res.data.response_data;
        setSelectedRowData(innerData);
        setEditMode(false);
        setFormData({
          id: innerData?.id,
          shipper: innerData?.shipper,
          assigned_to: innerData?.assigned_to,
          setting_status: innerData?.setting_status?.id,
          setting_department: innerData?.setting_department?.id,
        });
        fetchDepartment(innerData?.setting_department?.id);
      }
      // });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    fetchUser();
    // fetchStatus();
  };
  const fetchUser = async () => {
    try {
      const res = await withRFSToken
        .get(`uld-setting/get-user-list`, {})
        .then(function (res) {
          const innerData = res.data.Rows;
          const transformedData = innerData
            ? innerData.map((item) => ({
              value: item.user_id,
              label: item.first_name + " " + item.last_name,
              email: item.email_id,
            }))
            : [];
          setUserList(transformedData);
          // if (innerData.length > 0) {
          // if (!edidId) {
          //     const isDefault = innerData?.find(dflt => dflt.email_id == userId)
          //     setFormData(prevFormData => ({ ...prevFormData, assigned_to: isDefault?.user_id }))
          // }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchStatus = async () => {
    try {
      const res = await withRFSToken
        .get(`shipment/get-settings?tab=export&type=S`, {})
        .then(function (res) {
          const innerData = res.data.Rows;
          // const transformedData = innerData
          //   ? innerData.map((item) => ({
          //     value: item.id,
          //     label: item.name,
          //   }))
          //   : [];
          // setStatusList(transformedData);
          // if (innerData.length > 0) {
          //     const isDefault = innerData?.find(dflt => dflt.is_default === 1)
          //     setFormData(prevFormData => ({ ...prevFormData, setting_status: isDefault.id }))
          // }

        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchDepartment = async (id) => {
    try {
      const res = await withRFSToken
        .get(`shipment/get-settings?tab=export&type=D`, {})
        .then(function (res) {
          const innerData = res.data.Rows;
          const transformedData = innerData
            ? innerData.map((item) => ({
              value: item.id,
              label: item.name,
              status: item.status_are
            }))
            : [];
          setDepartmentList(transformedData);
          if (id) {
            const findDep = innerData.find(did => did.id === id)
            const transformedData = findDep.status_are
              ? findDep?.status_are?.map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [];
            setStatusList(transformedData);
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRefs[activeTab].current).jqxGrid("refresh");
    }, 30);
  };

  const handleDetailsEdit = () => {
    setEditMode(true);
    // fetchUser();
  };
  const handleEditSubmit = async () => {
    setEditMode(false);
    try {
      const res = await withRFSToken.post(
        "shipment/save-export-shipment-record",
        formData
      );
      if (res.data.response_code === 200) {
        toast.success(res.data.response_msg);
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error("Error saving shipment record:", error);
    }
    loadDetails(selectedRowData.id);
  };

  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };

  //   Upload
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  const imageModalUpload = (id) => {
    const selectedRowFiles =
      gridSelect.find((item) => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }
  const imageUpload = () => {
    setGridSelect((prevGridSelect) =>
      prevGridSelect.map((item) => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };
  //   Upload

  const AddRecords = () => {
    localStorage.removeItem("SHEdit");
    localStorage.setItem("ccbackUrl", "/ForwarderShipments/ShipmentRecords");
    localStorage.setItem("addexport", "true");
    localStorage.setItem("AddShipmentType", "export");
    history.push("/ForwarderShipments/AddShipmentRecords");
  };

  const openConf = () => {
    if (gridSelect.length > 0) {
      setShowConfirmation(true);
      setConfirmationInfo("D");
    } else {
      toast.error("Please select Shipment first");
    }
  };

  const handleShowConfirmation = (deleteFunction) => {
    setShowConfirmation(true);
    setDeleteFunction(() => deleteFunction);
  };
  const handleConfirmDelete = () => {
    deleteRow();
    // deleteFunction(deleteId)
    setShowConfirmation(false);
  };

  const handleCancelDelete = () => {
    setDeleteId("");
    setShowConfirmation(false);
  };
  const deleteRow = async (selectedId) => {
    const ids = gridSelect?.map((data) => data.id);
    try {
      const res = await withRFSToken.post("shipment/active-inactive-record", {
        tab: "export",
        id: ids,
        status: "D",
      });
      if (res.data.response_code == 200) {
        toast.success("User Data Removed Successfully");
        // fetchData();
        gridSelect.forEach((item) => {
          const selectedRowBoundIndex = item.boundindex;
          window
            .$(gridRefs[activeTab].current)
            .jqxGrid("unselectrow", selectedRowBoundIndex);
        });
        setGridSelect([]);
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
        setDeleteId("");
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };

  // active archive

  const handleMoveToActArc = (info) => {
    if (gridSelect.length <= 0) {
      toast.error("Please select Shipment first");
    } else {
      setShowConfirmation(true);
      setConfirmationInfo(info);
      // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
    }
  };
  const confirmMoveToActArc = async () => {
    const sendAction = activeTab == "Active" ? "I" : "A";
    const ids = gridSelect?.map((data) => data.id);
    try {
      const res = await withRFSToken
        .post("shipment/active-inactive-record", {
          tab: "export",
          status: sendAction,
          id: ids,
        })
        .then(function (res) {
          if (res.data.response_code == 200) {
            gridSelect.forEach((item) => {
              const selectedRowBoundIndex = item.boundindex;
              window
                .$(gridRefs[activeTab].current)
                .jqxGrid("unselectrow", selectedRowBoundIndex);
            });
            setGridSelect([]);
            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
            setShowConfirmation(false);
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Action modal functions for Open tab
  const handleActionModalOpen = async () => {
    if (gridSelect.length === 0) {
      toast.error("Please select at least one record from the grid");
      return;
    }
    // setActiveTab('Active');
    setShowActionModal(true);
    await fetchActionSelectOptions();
  };

  // const handleActionModalClose = () => {
  //     setShowActionModal(false);
  //     setSelectedActionOption(null);
  // };

  const fetchActionSelectOptions = async () => {
    setIsLoadingActionOptions(true);
    try {
      const res = await withRFSToken.get(
        "shipment/export-shipment-record-list?tab=Active"
      );
      if (res.data.Rows) {
        const options = res.data.Rows.map((item) => ({
          value: item.id,
          label: item.cargohub_id || item.id,
        }));
        setActionSelectOptions(options);
      } else {
        toast.error("Failed to load options");
        setActionSelectOptions([]);
      }
    } catch (error) {
      console.error("Error fetching action options:", error);
      toast.error("Failed to load options");
      setActionSelectOptions([]);
    } finally {
      setIsLoadingActionOptions(false);
    }
  };

  // const handleActionSubmit = async () => {
  //     if (!selectedActionOption) {
  //         toast.error('Please select an option');
  //         return;
  //     }
  //     if (gridSelect.length === 0) {
  //         toast.error('Please select at least one record from the grid');
  //         return;
  //     }

  //     const selectedIds = gridSelect.map(data => data.id);

  //     try {
  //         // Dummy API call - replace with actual endpoint when available
  //         const res = await withRFSToken.post('shipment/export-shipment-action', {
  //             selected_ids: selectedIds,
  //             action_option: selectedActionOption.value
  //         });

  //         if (res.data.response_code === 200) {
  //             toast.success(res.data.response_msg || 'Action completed successfully');
  //             handleActionModalClose();
  //             // Clear selections
  //             gridSelect.forEach(item => {
  //                 const selectedRowBoundIndex = item.boundindex;
  //                 window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
  //             });
  //             setGridSelect([]);
  //             window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
  //         } else {
  //             toast.error(res.data.response_msg || 'Failed to perform action');
  //         }
  //     } catch (error) {
  //         console.error('Error submitting action:', error);
  //         toast.error('Failed to perform action');
  //     }
  // };

  // Add ref for modal grid
  const modalGridRef = useRef(null);
  const [modalSelectedRows, setModalSelectedRows] = useState([]);
  const [nestedGridSelect, setNestedGridSelect] = useState([]);
  const [showDisconnectConfirm, setShowDisconnectConfirm] = useState(false);
  // ... existing code

  // Handler for modal grid row selection
  const handleModalRowSelect = (row) => {
    setModalSelectedRows((prev) => {
      if (!prev.some((r) => r.id === row.id)) {
        return [...prev, row];
      }
      return prev;
    });
  };

  const handleModalRowUnselect = (row) => {
    setModalSelectedRows((prev) => prev.filter((r) => r.id !== row.id));
  };
  const handleLabelClick = (rowData) => {
    console.log('Label clicked:', rowData);
  };

  const handleActionSubmit = async () => {
    if (modalSelectedRows.length === 0) {
      toast.error("Please select at least one record from the Active tab");
      return;
    } else if (modalSelectedRows.length > 1) {
      toast.error("Please select only one record from the Active tab");
      return;
    }
    if (gridSelect.length === 0) {
      toast.error("Please select at least one record from the Open tab");
      return;
    }

    const openTabIds = gridSelect.map((data) => data.awbId);
    const activeTabIds = modalSelectedRows.map((data) => data.id);

    try {
      const res = await withRFSToken.post("shipment/connect-record-id", {
        take_in_ids: openTabIds,
        export_shipment_record_id: activeTabIds[0],
      });

      if (res.data.response_code === 200) {
        toast.success(
          res.data.response_msg || "Records connected successfully"
        );
        handleActionModalClose();
        // Clear selections
        gridSelect.forEach((item) => {
          const selectedRowBoundIndex = item.boundindex;
          window
            .$(gridRefs[activeTab].current)
            .jqxGrid("unselectrow", selectedRowBoundIndex);
        });
        setGridSelect([]);
        setModalSelectedRows([]);
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
      } else {
        toast.error(res.data.response_msg || "Failed to connect records");
      }
    } catch (error) {
      console.error("Error submitting action:", error);
      toast.error("Failed to connect records");
    }
  };

  const handleActionModalClose = () => {
    setShowActionModal(false);
    setModalSelectedRows([]);
    if (modalGridRef.current) {
      modalGridRef.current.clearSelection();
    }
  };

  const handleDisconnectClick = () => {
    if (nestedGridSelect.length === 0) {
      toast.error("Please select at least one record from the nested grid");
      return;
    }
    setShowDisconnectConfirm(true);
  };
  const handleConfirmDisconnect = async () => {
    setShowDisconnectConfirm(false);

    const selectedIds = nestedGridSelect.map((data) => data.id);

    try {
      const res = await withRFSToken.post("shipment/disconnect-airway-bill", {
        take_in_ids: selectedIds,
      });

      if (res.data.response_code === 200) {
        toast.success(res.data.response_msg || "Records disconnected successfully");
        setNestedGridSelect([]);
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
      } else {
        toast.error(res.data.response_msg || "Failed to disconnect records");
      }
    } catch (error) {
      console.error("Error disconnecting records:", error);
      toast.success("Dummy Disconnect Success (API likely not found)");
      setNestedGridSelect([]);
      window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
    }
  };
  const [checksModalType, setChecksModalType] = useState("checks");
  // Checks modal functions
  const openChecksModal = async (id, type = "checks") => {
    setChecksModalType(type);
    setChecksRecordId(id);
    setShowChecksModal(true);
    setIsLoadingChecks(true);
    try {
      const res = await withRFSToken.post(`shipment/export-shipment-record-details/${id}`, {});
      if (res.data.response_code === 200) {
        const innerData = res.data.response_data;
        setChecksFormData({ ...innerData });
      } else {
        toast.error(res.data.response_msg || "Failed to load checks data");
      }
    } catch (error) {
      console.error("Error fetching checks data:", error);
      toast.error("Failed to load checks data");
    } finally {
      setIsLoadingChecks(false);
    }
  };

  const closeChecksModal = () => {
    setShowChecksModal(false);
    setChecksFormData({});
    setChecksRecordId(null);
    // setChecksModalType('checks'); // Reset to default
  };

  const handleChecksInputChange = (name, value) => {
    if (name === "pick_up_check") {
      if (value === "1") {
        const now = new Date();
        const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
        setChecksFormData({
          ...checksFormData,
          pick_up_check: value,
          pick_up: formattedDate,
        });
      } else {
        setChecksFormData({
          ...checksFormData,
          pick_up_check: value,
          pick_up: "",
        });
      }
      return;
    }
    if (name === "warehouse_inbound_check") {
      if (value === "1") {
        const now = new Date();
        const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
        setChecksFormData({
          ...checksFormData,
          warehouse_inbound_check: value,
          warehouse_inbound: formattedDate,
        });
      } else {
        setChecksFormData({
          ...checksFormData,
          warehouse_inbound_check: value,
          warehouse_inbound: "",
        });
      }
      return;
    }

    if (name === "screening_planned") {
      const now = new Date();
      const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
      if (value === "1") {
        setChecksFormData((prev) => ({
          ...prev,
          screening: "0",
          screening_date: "",
          screening_planned: "1",
          screening_planned_date: formattedDate,
        }));
      } else {
        setChecksFormData({
          ...checksFormData,
          screening_planned: "0",
          screening_planned_date: "",
          screening: "0",
          screening_date: "",
        });
      }
      return;
    }

    if (name === "screening") {
      const now = new Date();
      const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
      if (value === "1") {
        setChecksFormData((prev) => ({
          ...prev,
          sec_status: "S",
          screening: "1",
          screening_date: formattedDate,
        }));
      } else {
        setChecksFormData({
          ...checksFormData,
          sec_status: "U",
          screening: "0",
          screening_date: "",
        });
      }
      return;
    }

    if (name === "sec_status") {
      if (value === "S") {
        const now = new Date();
        const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
        setChecksFormData({
          ...checksFormData,
          screening: "1",
          screening_date: formattedDate,
          sec_status: "S",
        });
      } else if (value === "U") {
        setChecksFormData({
          ...checksFormData,
          screening: "0",
          screening_date: "",
          screening_planned: "0",
          screening_planned_date: "",
          sec_status: value,
        });
      } else if (value === "K") {
        setChecksFormData({
          ...checksFormData,
          screening: "0",
          screening_date: "",
          screening_planned: "0",
          screening_planned_date: "",
          sec_status: value,
        });
      }
      return;
    }

    if (name === "checks_completed_check") {
      if (value === "1") {
        const now = new Date();
        const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
        setChecksFormData({
          ...checksFormData,
          checks_completed_check: value,
          checks_completed: formattedDate,
        });
      } else {
        setChecksFormData({
          ...checksFormData,
          checks_completed_check: value,
          checks_completed: "",
        });
      }
      return;
    }
    setChecksFormData({
      ...checksFormData,
      [name]: value,
    });
  };

  const handleChecksSave = async () => {
    try {
      const res = await withRFSToken.post(
        "shipment/save-export-shipment-record",
        checksFormData
      );
      if (res.data.response_code === 200) {
        toast.success(res.data.response_msg || "Checks updated successfully");
        closeChecksModal();
        // Refresh the grid
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
      } else {
        toast.error(res.data.response_msg || "Failed to update checks");
      }
    } catch (error) {
      console.error("Error saving checks:", error);
      toast.error("Failed to update checks");
    }
  };

  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
  };
  return (
    <>

      <div className="mb-3 nestedtabs rounded minh nested_tab">
        <div className="d-flex">
          <button className="addtruck me-2" variant="primary" onClick={AddRecords}>
            <span>
              <FontAwesomeIcon icon={faPlus} /> Add Export
            </span>
          </button>
          {(activeTab === "Open" || activeTab == "Active") && (
            <Dropdown>
              <Dropdown.Toggle variant="light" id="dropdown-basic" className="action me-2">
                <FontAwesomeIcon icon={faGear} /> Actions{" "}
                <FontAwesomeIcon icon={faChevronDown} />
              </Dropdown.Toggle>
              {activeTab === "Open" && (
                <Dropdown.Menu>
                  <Dropdown.Item onClick={handleActionModalOpen}>
                    Connect Export
                  </Dropdown.Item>
                </Dropdown.Menu>
              )}
              {activeTab === "Active" && (
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => openAwbModal()}
                    disabled={gridSelect.length === 0}
                  >
                    Set AirwayBill
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleDisconnectClick()}
                    disabled={nestedGridSelect.length === 0}
                  >Disconnect
                  </Dropdown.Item>
                </Dropdown.Menu>
              )}
            </Dropdown>
          )}

          <div className="ulddown">
            <button onClick={() => handleMoveToActArc(activeTab === "Active" ? "R" : "A")}>
              <img title="" src={activeTab === "Active" ? Arcv : Activ} />{" "}
              {activeTab === "Active" ? "Archive" : "Active"}
            </button>
            {/* {activeTab !== "Trash" && (
              <button onClick={openConf}><img title="" src={trash} /> Trash</button>
            )} */}
          </div>
        </div>
      </div>
      <div className="maindiv">
        <div className="trashdonload">
          <Tabs defaultActiveKey={activeTab} onSelect={(tab) => (activeTab !== tab ? handleTabChange(tab) : "")} id="station-tabs" className="booking_tab">
            <Tab eventKey="Open" title={<span>Open <Badge className="rabadge">{totalRows}</Badge></span>} className="moveto">
              {/* <Loader isLoading={isLoading} /> */}
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && (
                <>
                  <div ref={gridRefs.Open} className="bookinggrid"></div>
                </>
              )}
              {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
            </Tab>
            <Tab eventKey="Active" title={<span>Active</span>} className="moveto">
              {/* <Loader isLoading={isLoading} /> */}
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && (
                <>
                  <div ref={gridRefs.Active} className="bookinggrid"></div>
                </>
              )}
              {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
            </Tab>
            {/* <Tab eventKey="PickupPlanned" title={<span>Pickup </span>} className="moveto"> */}
            {/* <Loader isLoading={isLoading} /> */}
            {/* {filterApplied ? <> <div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <>
               <div ref={gridRefs.PickupPlanned} className="bookinggrid"></div>
              </>} */}
            {/* <div ref={gridRefs.Trash} className='bookinggrid' ></div> */}
            {/* </Tab> */}
            {/* <Tab eventKey="Booked" title={<span>Booked </span>} className="moveto"> */}
            {/* <Loader isLoading={isLoading} /> */}
            {/* {filterApplied ? <> <div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <>
               <div ref={gridRefs.Booked} className="bookinggrid"></div>
              </>} */}
            {/* <div ref={gridRefs.Trash} className='bookinggrid' ></div> */}
            {/* </Tab> */}
            {/* <Tab eventKey="Invoicing" title={<span>Invoicing </span>} className="moveto"> */}
            {/* <Loader isLoading={isLoading} /> */}
            {/* {filterApplied ? <> <div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <>
               <div ref={gridRefs.Invoicing} className="bookinggrid"></div>
              </>} */}
            {/* <div ref={gridRefs.Trash} className='bookinggrid' ></div> */}
            {/* </Tab> */}
            <Tab eventKey="Archived" title={<span>Archived </span>} className="moveto">
              {/* <Loader isLoading={isLoading} /> */}
              {filterApplied ? <> <div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <>
                <div ref={gridRefs.Archived} className="bookinggrid"></div>
              </>}
              {/* <div ref={gridRefs.Trash} className='bookinggrid' ></div> */}
            </Tab>

            <Tab eventKey="History" title={<span>History </span>} className="moveto">
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && (
                <>
                  <div ref={gridRefs.History} className="bookinggrid"></div>
                </>
              )}
            </Tab>

            {/* <Tab eventKey="Trash" title={<span>Trash </span>} className="moveto">
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading &&  <>
                <div ref={gridRefs.Trash} className="bookinggrid"></div>
                </>
              }
             
            </Tab> */}
          </Tabs>
          {/* {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>} */}
        </div>
        {selectedRowData && (
          <div className="SecondDiv mt-45">
            <button className="close" onClick={handleCloseClick}>
              <FontAwesomeIcon icon={faXmark} />
            </button>
            <div className="girddtals_header">
              <h3>
                {selectedRowData.cargohub_id} &nbsp; <span></span>
              </h3>
              <div className="d-flex actbtn justify-content-between">
                <Button variant="light" onClick={browseClick}><FontAwesomeIcon icon={faPaperclip} />Attach</Button>
                <div className='viwall'>
                  <Link to='#' onClick={() => OrderViewDetailsClick(selectedRowData)}>View Details</Link>
                </div>
              </div>
            </div>
            <div className="update_info">

              <h4 className="mb-2">Created : <span>{new Date(selectedRowData?.created_at).toISOString().slice(0, 16).replace("T", " ")}</span></h4>
              <h4 className="mb-2">Created By : <span>{selectedRowData?.created_user?.first_Name} {selectedRowData?.created_user?.last_Name} </span></h4>
              <h4 className="mb-2">Shipper : <span>{selectedRowData?.shipper} </span></h4>
              <h4 className="mb-2">Consignee : <span>{selectedRowData?.consignee} </span></h4>
              <h4 className="mb-2">Total Pieces : <span>{selectedRowData?.ttl_pcs} </span></h4>

              <div className="d-flex justify-content-between align-items-center MB-2">
                <h4>Update Status</h4>
                {editMode ? (
                  <Link to="#" onClick={handleEditSubmit}>
                    <FontAwesomeIcon icon={faCircleCheck} />
                  </Link>
                ) : (
                  <Link to="#" onClick={handleDetailsEdit}>
                    <FontAwesomeIcon icon={faPencil} />
                  </Link>
                )}
              </div>

              <ul>
                <li>
                  <span>Assigned User :</span>
                  <span>
                    {editMode ? (
                      <Form.Group className="my-2">
                        <Select
                          options={userList}
                          onChange={(selected) => {
                            setFormData({
                              ...formData,
                              assigned_to: selected.value,
                            });
                          }}
                          placeholder="User"
                          className="autoslct w-100"
                          name="assigned_to"
                          value={
                            formData.assigned_to
                              ? userList.find(
                                (option) =>
                                  option.value === formData.assigned_to
                              )
                              : null
                          }
                        />
                      </Form.Group>
                    ) : (
                      <>
                        {selectedRowData?.assigned_user
                          ? selectedRowData?.assigned_user?.first_Name +
                          " " +
                          selectedRowData?.assigned_user?.last_Name
                          : ""}
                      </>
                    )}
                  </span>
                </li>
                <li>
                  <span>Department :</span>
                  <span>
                    {editMode ? (
                      <Form.Group className="my-2">
                        <Select
                          options={departmentList}
                          onChange={(selected) => {
                            setFormData({
                              ...formData,
                              setting_department: selected.value,
                              setting_status: null
                            });
                            const transformedData = selected.status
                              ? selected.status.map((item) => ({
                                value: item.id,
                                label: item.name,
                              }))
                              : [];
                            setStatusList(transformedData);
                          }}
                          placeholder="Department"
                          className="autoslct w-100"
                          name="setting_department"
                          value={formData.setting_department ? departmentList.find(option => option.value === formData?.setting_department) : null}
                        />
                      </Form.Group>
                    ) : (
                      <>{selectedRowData?.setting_department?.name}</>
                    )}
                  </span>
                </li>
                <li>
                  <span>Status :</span>
                  <span>
                    {editMode ? (
                      <Form.Group className="my-2">
                        <Select
                          options={statusList}
                          onChange={(selected) => {
                            setFormData({
                              ...formData,
                              setting_status: selected.value,
                            });
                          }}
                          placeholder="Status"
                          className="autoslct w-100"
                          name="setting_status"
                          value={formData.setting_status ? statusList.find(option => option.value === formData?.setting_status) : null}
                        />
                      </Form.Group>
                    ) : (
                      <>{selectedRowData?.setting_status?.name}</>
                    )}
                  </span>
                </li>

              </ul>
            </div>
            <div className="movment_list">
              <ul>
                {/* {selectedRowData && selectedRowData.movement_history.slice(0, 5).map((history, index) => (
                                              <li key={index}>
                                                <span className='movem'>{history.operation_type}</span> <span className='mvdate'>{history.operation_date}</span>
                                                <Link to="#" onClick={() => handleDetailsClick(history)}>Details</Link>
                                              </li>
                                            ))} */}
              </ul>
            </div>
            <ImageUpload
              ref={imageUploadRef}
              attachable_type={"exp_shipment_record"}
              attachable_id={selectedRowData.id}
              attachments={selectedRowData.attachments}
              attachment_no={selectedRowData.cargohub_id}
              onDeleteSuccess={() => loadDetails(selectedRowData.id)}
            />
            <ActivityComments
              commentable_type={"exp_shipment_record"}
              commentable_id={selectedRowData.id}
              allactivities={selectedRowData.activities}
              onReloadDetails={() => loadDetails(selectedRowData.id)}
            />
          </div>
        )}
      </div>
      <Modal className="addfrom change_type" show={isAwbModalOpen} onHide={closeAwbModal} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h3>Set Airwaybill</h3>
          <p className="mb-2 text-muted">
            Updating {awbModalData.ids.length} record
            {awbModalData.ids.length === 1 ? "" : "s"}.
          </p>
          <Form.Label>
            Airway Bill Number<span>*</span>
          </Form.Label>
          <Form.Control
            type="text"
            name="airwaybill"
            value={awbModalData.airwaybill}
            maxLength={13}
            placeholder="000-0000 0000"
            onChange={(e) => handleAwbChange(e.target.value)}
          />
          <div className="saairbill mt-3">
            <Form.Label>
              Cut Off Date<span>*</span>
            </Form.Label>
            <Form.Control
              type="datetime-local"
              name="cutOffTime"
              value={
                awbModalData?.cutOffTime
                  ? awbModalData.cutOffTime
                  : getCurrentDateTime()
              }
              onChange={(e) =>
                setAwbModalData((prev) => ({
                  ...prev,
                  cutOffTime: e.target.value,
                }))
              }
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={updateAwb}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        className="raintrac"
        show={showConfirmation}
        onHide={() => setShowConfirmation(false)}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h2>
            {confirmationInfo == "D"
              ? "Confirm Delete"
              : `Selected ${gridSelect.length > 1 ? "Shipment's" : "Shipment"
              } will move to ${activeTab == "Active" ? "Archive" : "Active"}`}
          </h2>
          <p>
            If you proceed with the change, user data will be{" "}
            {confirmationInfo == "D"
              ? "removed"
              : `moved to ${activeTab == "Active" ? "Archive" : "Active"}`}
            . Are you sure you want to continue?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDelete}>
            No
          </Button>
          <Button
            variant="primary"
            onClick={
              confirmationInfo == "D"
                ? handleConfirmDelete
                : confirmMoveToActArc
            }
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        className="addfrom change_type"
        show={showActionModal}
        onHide={handleActionModalClose}
        centered
        size="xl"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h3>Connect Export</h3>
          {/* <div className="mb-3">
            <p className="mb-1">
              Selected from Open tab:{" "}
              <strong>{gridSelect.length} record(s)</strong>
            </p>
            <p className="mb-1">
              Selected from Active tab:{" "}
              <strong>{modalSelectedRows.length} record(s)</strong>
            </p>
          </div> */}
          {/* <div className='alert alert-info'>
                        <small>Select records from the Active tab below to connect with the Open tab records</small>
                    </div> */}
          <div className="bookinggrid">
            <GenericJqxGrid
              ref={modalGridRef}
              tab="Active"
              apiUrl={`${process.env.REACT_APP_RFS_URL}shipment/export-shipment-record-list?tab=Active`}
              datafields={exportShipmentDatafields}
              columns={exportShipmentColumns}
              showActions={false}
              selectionMode="checkbox"
              height={500}
              pageSize={50}
              onRowSelect={handleModalRowSelect}
              onRowUnselect={handleModalRowUnselect}
              onCustomClick={{
                labelId_click: handleLabelClick
              }}
              autoLoadFilters={false}
              idPrefix="export-shipment"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={handleActionModalClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleActionSubmit}
              disabled={modalSelectedRows.length === 0}
            >
              Connect Records
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        className="addfrom change_type"
        show={showChecksModal}
        onHide={closeChecksModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {checksModalType === "checks"
              ? "Checks"
              : checksModalType === "screening"
                ? "Screening"
                : "Security Status"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoadingChecks ? (
            <div className="text-center p-4">Loading...</div>
          ) : (
            <div className="flbg details h-100 record_export_modal">
              <ul className="checks">
                {/* Show only Screening field when screening modal type */}
                {/* {checksModalType === "screening" && (
                  <li>
                    <span className="d-flex align-items-base-line justify-content-between gap-3">
                      <span style={{ minWidth: "180px", color: "inherit" }}>
                        Screening :
                      </span>
                      <span className="d-flex" style={{ minWidth: "220px" }}>
                        <Form.Check
                          inline
                          type="radio"
                          label="Yes"
                          name="screening"
                          checked={checksFormData.screening == "1"}
                          onChange={() =>
                            handleChecksInputChange("screening", "1")
                          }
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label="No"
                          name="screening"
                          checked={checksFormData.screening == "0"}
                          onChange={() =>
                            handleChecksInputChange("screening", "0")
                          }
                        />
                      </span>
                      <Form.Control
                        type="datetime-local"
                        name="screening_date"
                        value={checksFormData?.screening_date || ""}
                        onChange={(e) =>
                          handleChecksInputChange(
                            "screening_date",
                            e.target.value
                          )
                        }
                        style={{ maxWidth: "230px" }}
                        className="date_picker"
                      />
                    </span>
                  </li>
                )} */}

                {/* Show only Sec Status field when sec_status modal type */}
                {checksModalType === "sec_status" && (
                  <>
                    <li className="">
                      <span className="d-flex align-items-base-line justify-content-between gap-3">
                        <span style={{ minWidth: "170px", color: "inherit" }}>
                          Security Status :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Known"
                            id="Known-1"
                            name="sec_status"
                            value="K"
                            checked={checksFormData?.sec_status == "K"}
                            onChange={(e) => handleChecksInputChange("sec_status", "K")}
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="Unknown"
                            id="Known-2"
                            name="sec_status"
                            value="U"
                            checked={checksFormData?.sec_status == "U"}
                            onChange={(e) => handleChecksInputChange("sec_status", "U")}
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="Screened"
                            id="Known-3"
                            name="sec_status"
                            value="S"
                            checked={checksFormData?.sec_status === "S"}
                            onChange={(e) => handleChecksInputChange("sec_status", "S")}
                          />
                        </span>
                      </span>
                    </li>

                    <li className="">
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "170px", color: "inherit" }}>
                          Screening Planned :{" "}
                          {checksFormData?.sec_status != "K" ? <span>*</span> : ""}
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            name="screening_planned"
                            checked={checksFormData?.screening_planned == "1"}
                            onChange={() =>
                              handleChecksInputChange("screening_planned", "1")
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            name="screening_planned"
                            checked={checksFormData?.screening_planned == "0"}
                            onChange={() =>
                              handleChecksInputChange("screening_planned", "0")
                            }
                          />
                        </span>
                        <Form.Control
                          type="datetime-local"
                          name="screening_planned_date"
                          value={checksFormData?.screening_planned_date}
                          onChange={(e) =>
                            handleChecksInputChange(
                              "screening_planned_date",
                              e.target.value
                            )
                          }
                          style={{ maxWidth: "230px" }}
                        />
                      </span>
                    </li>

                    <li className="">
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "170px", color: "inherit" }}>
                          Screened :{" "}
                          {checksFormData?.sec_status != "K" ? <span>*</span> : ""}
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            name="screening"
                            checked={checksFormData?.screening == "1"}
                            onChange={() => handleChecksInputChange("screening", "1")}
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            name="screening"
                            checked={checksFormData?.screening == "0"}
                            onChange={() => handleChecksInputChange("screening", "0")}
                          />
                        </span>
                        <Form.Control
                          type="datetime-local"
                          name="screening_date"
                          value={checksFormData?.screening_date}
                          onChange={(e) =>
                            handleChecksInputChange("screening_date", e.target.value)
                          }
                          style={{ maxWidth: "230px" }}
                        />
                      </span>
                    </li>
                  </>
                )}
                {/* Show all fields for checks modal type */}
                {checksModalType === "checks" && (
                  <>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          Pick Up :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            name="pick_up_check"
                            checked={checksFormData.pick_up_check == "1"}
                            onChange={() =>
                              handleChecksInputChange("pick_up_check", "1")
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            name="pick_up_check"
                            checked={checksFormData.pick_up_check == "0"}
                            onChange={() =>
                              handleChecksInputChange("pick_up_check", "0")
                            }
                          />
                        </span>
                        <Form.Control
                          type="datetime-local"
                          name="pick_up"
                          value={checksFormData?.pick_up || ""}
                          onChange={(e) =>
                            handleChecksInputChange("pick_up", e.target.value)
                          }
                          style={{ maxWidth: "230px" }}
                          className="date_picker"
                        />
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          Warehouse Inbound :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            name="warehouse_inbound_check"
                            checked={
                              checksFormData.warehouse_inbound_check == "1"
                            }
                            onChange={() =>
                              handleChecksInputChange(
                                "warehouse_inbound_check",
                                "1"
                              )
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            name="warehouse_inbound_check"
                            checked={
                              checksFormData.warehouse_inbound_check == "0"
                            }
                            onChange={() =>
                              handleChecksInputChange(
                                "warehouse_inbound_check",
                                "0"
                              )
                            }
                          />
                        </span>
                        <Form.Control
                          type="datetime-local"
                          name="warehouse_inbound"
                          value={checksFormData?.warehouse_inbound || ""}
                          onChange={(e) =>
                            handleChecksInputChange(
                              "warehouse_inbound",
                              e.target.value
                            )
                          }
                          style={{ maxWidth: "230px" }}
                          className="date_picker"
                        />
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          Customs Document :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            id="customs_document-1"
                            name="customs_document"
                            value="true"
                            checked={checksFormData?.customs_document === "1"}
                            onChange={(e) =>
                              handleChecksInputChange("customs_document", "1")
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            id="customs_document-2"
                            name="customs_document"
                            value="false"
                            checked={checksFormData?.customs_document === "0"}
                            onChange={(e) =>
                              handleChecksInputChange("customs_document", "0")
                            }
                          />
                        </span>
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          Ex-a Prepared :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            id="exa_prepared_by_kerry-1"
                            name="exa_prepared_by_kerry"
                            value="true"
                            checked={
                              checksFormData?.exa_prepared_by_kerry === "1"
                            }
                            onChange={(e) =>
                              handleChecksInputChange(
                                "exa_prepared_by_kerry",
                                "1"
                              )
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            id="exa_prepared_by_kerry-2"
                            name="exa_prepared_by_kerry"
                            value="false"
                            checked={
                              checksFormData?.exa_prepared_by_kerry === "0"
                            }
                            onChange={(e) =>
                              handleChecksInputChange(
                                "exa_prepared_by_kerry",
                                "0"
                              )
                            }
                          />
                        </span>
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          Documents :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            id="documents-1"
                            name="documents"
                            value="true"
                            checked={checksFormData?.documents === "1"}
                            onChange={(e) =>
                              handleChecksInputChange("documents", "1")
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            id="documents-2"
                            name="documents"
                            value="false"
                            checked={checksFormData?.documents === "0"}
                            onChange={(e) =>
                              handleChecksInputChange("documents", "0")
                            }
                          />
                        </span>
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          AWB Instruction :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            id="awb_instruction-1"
                            name="awb_instruction"
                            value="true"
                            checked={checksFormData?.awb_instruction === "1"}
                            onChange={(e) =>
                              handleChecksInputChange("awb_instruction", "1")
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            id="awb_instruction-2"
                            name="awb_instruction"
                            value="false"
                            checked={checksFormData?.awb_instruction === "0"}
                            onChange={(e) =>
                              handleChecksInputChange("awb_instruction", "0")
                            }
                          />
                        </span>
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          AWB Draft Send :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            id="awb_draft_send-1"
                            name="awb_draft_send"
                            value="true"
                            checked={checksFormData?.awb_draft_send === "1"}
                            onChange={(e) =>
                              handleChecksInputChange("awb_draft_send", "1")
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            id="awb_draft_send-2"
                            name="awb_draft_send"
                            value="false"
                            checked={checksFormData?.awb_draft_send === "0"}
                            onChange={(e) =>
                              handleChecksInputChange("awb_draft_send", "0")
                            }
                          />
                        </span>
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          AWB Approved :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            id="awb_approved-1"
                            name="awb_approved"
                            value="true"
                            checked={checksFormData?.awb_approved === "1"}
                            onChange={(e) =>
                              handleChecksInputChange("awb_approved", "1")
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            id="awb_approved-2"
                            name="awb_approved"
                            value="false"
                            checked={checksFormData?.awb_approved === "0"}
                            onChange={(e) =>
                              handleChecksInputChange("awb_approved", "0")
                            }
                          />
                        </span>
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          Pre-Alert Send :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            id="pre_alert_send-1"
                            name="pre_alert_send"
                            value="true"
                            checked={checksFormData?.pre_alert_send === "1"}
                            onChange={(e) =>
                              handleChecksInputChange("pre_alert_send", "1")
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            id="pre_alert_send-2"
                            name="pre_alert_send"
                            value="false"
                            checked={checksFormData?.pre_alert_send === "0"}
                            onChange={(e) =>
                              handleChecksInputChange("pre_alert_send", "0")
                            }
                          />
                        </span>
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          FWB + FHL :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            id="fwb_fhl-1"
                            name="fwb_fhl"
                            value="true"
                            checked={checksFormData?.fwb_fhl === "1"}
                            onChange={(e) =>
                              handleChecksInputChange("fwb_fhl", "1")
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            id="fwb_fhl-2"
                            name="fwb_fhl"
                            value="false"
                            checked={checksFormData?.fwb_fhl === "0"}
                            onChange={(e) =>
                              handleChecksInputChange("fwb_fhl", "0")
                            }
                          />
                        </span>
                      </span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center justify-content-between gap-3">
                        <span style={{ minWidth: "180px", color: "inherit" }}>
                          Checks Completed :
                        </span>
                        <span className="d-flex" style={{ minWidth: "220px" }}>
                          <Form.Check
                            inline
                            type="radio"
                            label="Yes"
                            name="checks_completed_check"
                            checked={
                              checksFormData.checks_completed_check == "1"
                            }
                            onChange={() =>
                              handleChecksInputChange(
                                "checks_completed_check",
                                "1"
                              )
                            }
                          />
                          <Form.Check
                            inline
                            type="radio"
                            label="No"
                            name="checks_completed_check"
                            checked={
                              checksFormData.checks_completed_check == "0"
                            }
                            onChange={() =>
                              handleChecksInputChange(
                                "checks_completed_check",
                                "0"
                              )
                            }
                          />
                        </span>
                        <Form.Control
                          type="datetime-local"
                          name="checks_completed"
                          value={checksFormData?.checks_completed || ""}
                          onChange={(e) =>
                            handleChecksInputChange(
                              "checks_completed",
                              e.target.value
                            )
                          }
                          style={{ maxWidth: "230px" }}
                          className="date_picker"
                        />
                      </span>
                    </li>
                  </>
                )}
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={closeChecksModal}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleChecksSave}
              disabled={isLoadingChecks}
            >
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        className="raintrac"
        show={showDisconnectConfirm}
        onHide={() => setShowDisconnectConfirm(false)}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h2>Confirm Disconnect</h2>

          <p>
            {nestedGridSelect.length} record
            {nestedGridSelect.length > 1 ? "s" : ""} will be disconnected.
            <br />
            Are you sure you want to continue?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDisconnectConfirm(false)}>
            No
          </Button>

          <Button variant="primary" onClick={handleConfirmDisconnect}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default RecordExport;
